import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { DEFAULT_AGENT_IMAGE, resolveWidgetAssetUrl } from "../config";
export function ClosedFlowCard({ agentName, agentImage, message, flows, onPick, onDismiss, align, contentColor, surfaceColor, suggestionColor, t, }) {
    const [hoveredFlowId, setHoveredFlowId] = React.useState(null);
    const FLOW_SUGGESTION_MAX_CHARS = 34;
    const surface = surfaceColor || "rgba(255,255,255,0.08)";
    const text = contentColor || "#e2e8f0";
    const suggestion = suggestionColor || "rgba(255,255,255,0.12)";
    const avatarSource = resolveWidgetAssetUrl(agentImage) || resolveWidgetAssetUrl(DEFAULT_AGENT_IMAGE) || DEFAULT_AGENT_IMAGE;
    const truncateLabel = (value, maxChars = FLOW_SUGGESTION_MAX_CHARS) => {
        if (value.length <= maxChars)
            return value;
        return `${value.slice(0, Math.max(0, maxChars - 3)).trimEnd()}...`;
    };
    return (_jsx("div", { style: {
            display: "flex",
            flexDirection: "column",
            gap: 8,
            alignItems: align === "left" ? "flex-start" : "flex-end",
            marginBottom: 14,
        }, children: _jsxs("div", { style: {
                background: surface,
                color: text,
                border: "none",
                borderRadius: 14,
                padding: "12px 12px 10px",
                maxWidth: 260,
                width: "min(260px, 70vw)",
                boxShadow: "0 12px 36px rgba(0,0,0,0.28)",
                backdropFilter: "blur(6px)",
                display: "grid",
                gap: 8,
                position: "relative",
            }, children: [_jsx("div", { style: {
                        position: "absolute",
                        bottom: -6,
                        right: align === "right" ? 24 : undefined,
                        left: align === "left" ? 24 : undefined,
                        width: 12,
                        height: 12,
                        background: surface,
                        transform: "rotate(45deg)",
                    } }), _jsxs("div", { style: { display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12 }, children: [_jsxs("div", { style: { display: "flex", alignItems: "center", gap: 8, minWidth: 0 }, children: [_jsx("img", { src: avatarSource, alt: agentName, style: { width: 22, height: 22, borderRadius: "50%", objectFit: "cover", flexShrink: 0 } }), _jsx("div", { style: { fontSize: 12, fontWeight: 700, opacity: 0.8, minWidth: 0, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }, children: agentName })] }), _jsx("button", { onClick: onDismiss, "aria-label": t("closedFlows.dismiss"), style: {
                                border: "none",
                                background: "transparent",
                                color: text,
                                cursor: "pointer",
                                fontSize: 16,
                                lineHeight: 1,
                                opacity: 0.7,
                            }, children: "\u00D7" })] }), _jsx("div", { style: { fontSize: 13, lineHeight: 1.4 }, children: message }), _jsx("div", { style: {
                        display: "grid",
                        gap: 6,
                        justifyItems: "end",
                        width: "100%",
                        maxWidth: "100%",
                    }, children: flows.map((flow) => (_jsx("button", { onClick: () => onPick(flow), onMouseEnter: () => setHoveredFlowId(flow.id), onMouseLeave: () => setHoveredFlowId(null), style: {
                            all: "unset",
                            boxSizing: "border-box",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            alignSelf: "flex-end",
                            borderRadius: 9999,
                            border: "none",
                            padding: "5px 9px",
                            background: hoveredFlowId === flow.id ? suggestion : suggestion,
                            color: text,
                            fontSize: 11,
                            lineHeight: 1.2,
                            cursor: "pointer",
                            minWidth: 0,
                            width: "auto",
                            maxWidth: "88%",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            transition: "background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease",
                            transform: hoveredFlowId === flow.id ? "translateY(-1px)" : "translateY(0)",
                            boxShadow: hoveredFlowId === flow.id ? "0 10px 20px rgba(0,0,0,0.32)" : "0 5px 12px rgba(0,0,0,0.24)",
                        }, title: flow.label, children: _jsx("span", { style: {
                                display: "block",
                                minWidth: 0,
                                maxWidth: "100%",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                            }, children: truncateLabel(flow.label, FLOW_SUGGESTION_MAX_CHARS) }) }, flow.id))) })] }) }));
}
